import { render, staticRenderFns } from "./GIF.vue?vue&type=template&id=4e32d3dd&scoped=true&"
var script = {}
import style0 from "./GIF.vue?vue&type=style&index=0&id=4e32d3dd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e32d3dd",
  null
  
)

export default component.exports